export class AsyncLock {
  private _lock = Promise.resolve();

  async acquire() {
    let release: () => void = null!;
    const nextLock = new Promise<void>(resolve => {
      release = resolve;
    });

    await this._lock;
    this._lock = nextLock;
    return {
      release,
      [Symbol.dispose]: () => {
        release();
      },
    };
  }
}
